


import { baseApiURL } from "../../Utilities/utility";
import axios from "axios";

export function getZcode(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/ZCodeMaster/GetZCodes", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getZcodeTableData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId
) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },
    };
    return fetch(baseApiURL + "/ZCodeMaster/GetZCodeMaster",options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function addZcodeData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            Gid: gid,
            RoleName: roleName,
            Roleid: roleId,
            userId : userId
            
        },
        body: JSON.stringify(data),
    };
    return fetch(baseApiURL + "/ZCodeMaster/CreateZCode", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function updateZcodeData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data


) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
            
            
        },
        body: JSON.stringify(data),
        
    };
    return fetch(baseApiURL + "/ZCodeMaster/EditZCode", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function deleteZcodeData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    categoryId
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: JSON.stringify(categoryId),
       
    };
    
    return fetch(baseApiURL + "/ZCodeMaster/DeleteZCode?id=" + categoryId , options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function SearchZcode(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    formData
) {
    
;    const options = {
        method: "post",
        headers: {
           
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            Gid: gid,
            RoleName: roleName,
            Roleid: roleId,
            userId : userId
            
        },
        body: formData,
    };
    return fetch(baseApiURL + "/ZCodeMaster/SearchZCodeType", options)
        .then((response) =>{
            if(!response.ok){
                throw new Error(`Http error !Status:${response.status}`)
            }
            return response.json()
        })
        
        
        
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

// export function ExportZCode(
//     siteToken,
//     azureToken,
//     userId,
//     userEmail,
//     gid,
//     roleName,
//     roleId,
//     categoryId
    
// ) {
//     const options = {
//         method: "post",
//         headers: {
//             Accept: "application/json, text/plain, */*",
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + siteToken.token,
//             UserEmail: userEmail,
//             RoleName: roleName,
//             Gid: gid,
//             Roleid: roleId,
//             AzureToken: azureToken,
//             userId : userId
//         },
//         body: JSON.stringify(categoryId),
       
//     };
    
//     return fetch(baseApiURL + "/ZCodeMaster/ExportZCode" , options)
//         .then((response) => response.json())
//         .then((data) => {
//             return data.result;
//         })
//         .catch((error) => {
//             console.log("Error : ", error);
//         });
// }

export function ExportZCode(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    categoryId
) {
    const options = {
        method: "post",
        url: baseApiURL + "/ZCodeMaster/ExportZCode",
        responseType: "arraybuffer",
       
        headers: {
             Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
       data:{ categoryId:categoryId}

    };
    return axios(options)
        .then((response) => {
            return response;
            console.log(response);
        })
        .catch((error) => {
            return error;
        });

}